<icc-tabs [tabs]="availableTabs" *ngIf="tabs && tabs.length && !searching" [activeTabIndex]="getSelectedTab()"
 (activated)="selectTab($event)" [class.icc-tabs_tab--hide]="tabs.length === 1 && hideSingleTab"></icc-tabs>

<div class="scroller-wrapper" #scroller (scroll)="onScroll()" *ngIf="scrollable">
    <virtual-scroller #scroll [parentScroll]="scroller" [items]="filteredItems$ | async"
        [enableUnequalChildrenSizes]="true">
        <div class="icc-list" #container>
            <div class="icc-list-item" *ngFor="let item of scroll.viewPortItems; trackBy: trackByFunction"
                [class.icc-list-item--selected]="isSelectedId(item.id)" [class.icc-list-item--disabled]="item.disabled" [matRippleDisabled]="item.disabled" (click)="onSelect(item)" matRipple
                [ngClass]="getItemHeightAndWidthClass()" [class.icc-list-item--color]="itemTemplate === 'itemColor'">
                <ng-container [ngTemplateOutlet]="itemTemplateDef" [ngTemplateOutletContext]="{ iccListItem: item }">
                </ng-container>
            </div>
        </div>
    </virtual-scroller>
</div>

<div class="icc-list" *ngIf="!scrollable" [class.no-scrollable]="!scrollable">
    <div class="icc-list-item" *ngFor="let item of (filteredItems$ | async)"
        [class.icc-list-item--selected]="isSelectedId(item.id)" [class.icc-list-item--disabled]="item.disabled" [matRippleDisabled]="item.disabled" (click)="onSelect(item)" matRipple
        [ngClass]="getItemHeightAndWidthClass()" [class.icc-list-item--color]="itemTemplate === 'itemColor'">
        <ng-container [ngTemplateOutlet]="itemTemplateDef" [ngTemplateOutletContext]="{ iccListItem: item }">
        </ng-container>
    </div>
</div>

<ng-template #itemOnlyImg let-item="iccListItem">
    <div class="item-onlyimg">
        <img class="item-onlyimg-img" [src]="item.imageUrl" [alt]="item.title" defaultImg>
    </div>
</ng-template>

<ng-template #itemColor let-item="iccListItem">
    <div class="item-color">
        <div
            class="item-color-fill"
            [style.backgroundColor]="item.color"
            [style.backgroundImage]="'url(' + item.imageUrl + ')'"
        ></div>
        <button mat-mini-fab class="item-color-info-button" *ngIf="item.showInfo" (click)="clickShowInfoButton(item)" color="secondary" [title]="item.description || ''">
            <mat-icon class="mat-18">info</mat-icon>
        </button>
        <button mat-mini-fab class="item-color-glazing-button" *ngIf="item.editGlazing" (click)="clickEditGlazingButton(item)" color="secondary" [title]="item.description">
            <mat-icon class="mat-18">build</mat-icon>
        </button>
        <p class="item-color-title">{{item.title}}</p>
    </div>
</ng-template>

<ng-template #itemImgTitleDescription let-item="iccListItem">
    <div class="item-imgTitleDescription" [ngClass]="vertical ? 'item-imgTitleDescription--vertical ' : ''">
        <img class="item-imgTitleDescription-img" [src]="item.imageUrl" [alt]="item.title" defaultImg>
        <p class="item-imgTitleDescription-title">{{item.title}}</p>
        <div [innerHTML] = "item.description" class="item-imgTitleDescription-description">{{item.description}}</div>
        <button mat-mini-fab class="item-imgTitleDescription-info-button mat-elevation-z0" *ngIf="item.showInfo " (click)="clickShowInfoButton(item)" color="secondary" [title]="item.description || ''">
            <mat-icon class="mat-18">info</mat-icon>
        </button>
        <button mat-mini-fab class="item-imgTitleDescription-glazing-button mat-elevation-z0" *ngIf="item.editGlazing" (click)="clickEditGlazingButton(item)" color="secondary" [title]="item.description">
            <mat-icon class="mat-18">build</mat-icon>
        </button>
    </div>
</ng-template>

<ng-template #mountingMethod let-item="iccListItem">
    <div class="item-imgTitleDescription">
        <img class="item-imgTitleDescription-img" [src]="item.img" [alt]="item.name" defaultImg>
        <p class="item-imgTitleDescription-title">{{item.name}}</p>
        <div [innerHTML] = "''" class="item-imgTitleDescription-description">{{item.description}}</div>
    </div>
</ng-template>

<ng-template #itemImgTitle let-item="iccListItem">
    <div class="item-imgTitle">
        <img class="item-imgTitle-img" [src]="item.imageUrl" [alt]="item.title" defaultImg>
        <p class="item-imgTitle-title">{{item.title}}</p>
        <button mat-mini-fab class="item-itemImgTitle-info-button mat-elevation-z0" *ngIf="item.showInfo " (click)="clickShowInfoButton(item)" color="secondary" [title]="item.description || ''">
            <mat-icon class="mat-18">info</mat-icon>
        </button>
        <button mat-mini-fab class="item-itemImgTitle-glazing-button" *ngIf="item.editGlazing" (click)="clickEditGlazingButton(item)" color="secondary" [title]="item.description">
            <mat-icon class="mat-18">build</mat-icon>
        </button>
    </div>
</ng-template>
<ng-template #itemOnlyTitle let-item="iccListItem">
    <div class="item-onlyTitle">
        <p class="item-onlyTitle-title">{{item.title}}</p>
    </div>
</ng-template>

